module.exports = __webpack_public_path__ + "static/media/User.afdb96cb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Icons/User.svg
// module id = 437
// module chunks = 0